'use strict';

import Vue from 'vue';

export default {
    props: {
        data: Array,
        editable: Boolean,
        checkboxes: Boolean,
        defaultsRow: String,
        defaultData: Object,
    },
    data() {
        return {
            oldDefaultValue: null,
            defaultRowDisabled: undefined,
        };
    },
    watch: {
        defaultData: {
            /**
            * @type Function
            */
            handler: function(val, oldVal) {
                const changed = {};
                if(this.oldDefaultValue) {
                    for(const [name, value] of Object.entries(val)) {
                        const oldValue = this.oldDefaultValue[name];
                        if(value !== oldValue) {
                            changed[name] = value;
                        }
                    }
                } else {
                    Object.assign(changed, val);
                }

                for(const row of this.data) {
                    for(const [name, value] of Object.entries(changed)) {
                        const oldValue = this.oldDefaultValue[name];
                        const rowValue = row[name];
                        if(!row.rowDisabled && (!rowValue || (rowValue === oldValue))) {
                            Vue.set(row, name, value);
                        }
                    }
                }

                this.oldDefaultValue = Object.assign({}, val);
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        insert() {
            const newObject = {};
            this.data.push(newObject);
        },
        remove(index) {
            this.data.splice(index, 1);
        },
        processDefaultCheckbox() {
            for(const row of this.data) {
                Vue.set(row, 'rowDisabled', this.defaultRowDisabled);
            }
        },
    },
};
